import { render, staticRenderFns } from "./TempC.vue?vue&type=template&id=cc017e34&scoped=true&"
import script from "./TempC.vue?vue&type=script&lang=js&"
export * from "./TempC.vue?vue&type=script&lang=js&"
import style0 from "./TempC.vue?vue&type=style&index=0&id=cc017e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc017e34",
  null
  
)

export default component.exports